export default __webpack_public_path__ + "static/media/coppel.ea1f1b64.png";